import generateToast from './ToastGenerator.js';

export async function modelChooser(url, itemIndex) {
	const params = new URLSearchParams();

	params.append('BRAND_ID', itemIndex);

	const { default: axios } = await import("axios");

	return axios
		.get(url, {
			params
		})
		.then((response) => {
			if (response.data.status) {
				let options = response.data.data;

				return options;
			} else {
				generateToast('Запрос не прошел', 'Попробуйте еще раз', '#FF0037', 'white', true);

				throw Error('incorrect');
			}
		})
		.catch((response) => {
			generateToast('Произошла ошибка', 'Мы уже работаем над проблемой!', '#FF0037', 'white', true);

			throw Error('error');
		});
}
